const imagePickerStatesKey = 'imagePicker.state' ;

const IMAGE_PICKER_IMAGE_SIZE = {
    DESKTOP: {
        WIDTH: '400',
        HEIGHT: '160'
    },
    TABLET: {
        WIDTH: '400',
        HEIGHT: '160'
    },
    MOBILE: {
        WIDTH: '400',
        HEIGHT: '160'
    }
};

export { imagePickerStatesKey, IMAGE_PICKER_IMAGE_SIZE };
